import React, { useState, useEffect } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { Button, Modal } from "react-bootstrap";
import { 
  FiSearch, 
  FiUser, 
  FiCalendar, 
  FiUsers, 
  FiMessageSquare, 
  FiMapPin,
  FiChevronLeft,
  FiChevronRight
} from "react-icons/fi";
import { FaHeart } from "react-icons/fa";
import "./home.css";
import "./responsive.css";
import NoDataImage from "../../background.gif";
import MemberPhotoSlider from "../common/MemberPhotoSlider";
import { getUserImages } from "../../utils/userImages";

// Hero Desktop & Mobile Banners
import desktopBanner1 from "../../assets/images/banners/desktop-banner-1.jpg";
import desktopBanner2 from "../../assets/images/banners/desktop-banner-2.jpg";
import mobileBanner1 from "../../assets/images/banners/mobile-banner-1.jpg";
import mobileBanner2 from "../../assets/images/banners/mobile-banner-2.jpg";

// Social Proof Avatars
import user1 from "../../assets/images/user/1.jpg";
import user2 from "../../assets/images/user/2.jpg";
import user3 from "../../assets/images/user/3.jpg";
import user4 from "../../assets/images/user/4.jpg";
import user5 from "../../assets/images/user/5.jpg";

const HERO_SLIDES = [
  {
    id: 1,
    desktop: desktopBanner1,
    mobile: mobileBanner1,
    alt: "Hindu Sanjog - Find Your Perfect Life Partner",
  },
  {
    id: 2,
    desktop: desktopBanner2,
    mobile: mobileBanner2,
    alt: "Hindu Sanjog - Every Match Has a Beautiful Story",
  },
];

const DEFAULT_CASTES = [
  "Brahmin",
  "Rajput",
  "Maratha",
  "Agarwal",
  "Gupta",
  "Kayastha",
  "Yadav",
  "Jat",
  "Kshatriya",
  "Bania",
  "Maheshwari",
  "Jain",
  "Khatri",
  "Arora",
  "Lingayat",
  "Reddy",
  "Nair",
  "Vanniyar",
  "Other"
];

const MOTHER_TONGUES = [
  "Hindi",
  "Marathi",
  "Gujarati",
  "Punjabi",
  "Bengali",
  "Telugu",
  "Tamil",
  "Kannada",
  "Malayalam",
  "Odia",
  "Marwari",
  "Sindhi",
  "Assamese",
  "English",
  "Other"
];

const POPULAR_CITIES = [
  "Delhi / NCR",
  "Mumbai",
  "Pune",
  "Bangalore",
  "Jaipur",
  "Lucknow",
  "Ahmedabad",
  "Kolkata",
  "Hyderabad",
  "Indore",
  "Chandigarh",
  "Surat",
  "Nagpur",
  "Bhopal",
  "Patna",
  "Kanpur",
  "Varanasi",
  "Other"
];

export default function Bnner() {
  const [casteOptions, setCasteOptions] = useState(DEFAULT_CASTES);

  const [formData, setFormData] = useState({
    lookingFor: "female", // "female" -> Bride, "male" -> Groom
    ageRange: "18 - 35",
    minAge: 18,
    maxAge: 35,
    religion: "Hindu",
    caste: "",
    motherTongue: "",
    city: "",
  });

  const [apiData, setApiData] = useState({});
  const [loading, setLoading] = useState(false);
  const [isOpenModal, setOpenModal] = useState(false);

  const handleModal = () => {
    setOpenModal(!isOpenModal);
  };

  useEffect(() => {
    // Fetch dynamic caste list if available
    axios
      .get(`${process.env.REACT_APP_API_BASE_URL}admin-mat/api/caste.php`)
      .then((response) => {
        if (Array.isArray(response.data?.data?.caste) && response.data.data.caste.length > 0) {
          setCasteOptions(response.data.data.caste);
        }
      })
      .catch((err) => {
        console.log("Using default caste options:", err);
      });
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "ageRange") {
      const parts = value.split("-").map((v) => parseInt(v.trim(), 10));
      setFormData((prev) => ({
        ...prev,
        ageRange: value,
        minAge: parts[0] || 18,
        maxAge: parts[1] || 35,
      }));
    } else {
      setFormData((prev) => ({ ...prev, [name]: value }));
    }
  };

  // Calculate age from DOB
  const calculateAge = (dob) => {
    if (!dob) return "N/A";
    const birthDate = new Date(dob);
    const today = new Date();
    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();
    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }
    return age;
  };

  // Format height (5.6 => 5'6")
  const formatHeight = (height) => {
    if (!height) return "N/A";
    const [feet, inches] = height.split(".");
    return `${feet}'${inches}"`;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const payload = new FormData();
    payload.append("gender", formData.lookingFor);
    payload.append("age", formData.maxAge);
    if (formData.caste && formData.caste !== "Select") {
      payload.append("caste", formData.caste);
    }
    if (formData.city && formData.city !== "Select City") {
      payload.append("city", formData.city);
    }

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}mycon/recently_joint_search`,
        payload
      );
      if (response.data && response.data.users) {
        setApiData(response.data);
      } else {
        setApiData({ users: [] });
      }
      handleModal();
    } catch (err) {
      console.error("Error fetching matching profiles:", err);
      // Even if API errors, show modal with fallback message / search option
      setApiData({});
      handleModal();
    } finally {
      setLoading(false);
    }
  };

  const [activeSlide, setActiveSlide] = useState(0);
  const [isPaused, setIsPaused] = useState(false);
  const [touchStart, setTouchStart] = useState(null);
  const [touchEnd, setTouchEnd] = useState(null);

  const nextSlide = () => {
    setActiveSlide((prev) => (prev + 1) % HERO_SLIDES.length);
  };

  const prevSlide = () => {
    setActiveSlide((prev) => (prev - 1 + HERO_SLIDES.length) % HERO_SLIDES.length);
  };

  useEffect(() => {
    if (isPaused) return;
    const interval = setInterval(() => {
      setActiveSlide((prev) => (prev + 1) % HERO_SLIDES.length);
    }, 5500);
    return () => clearInterval(interval);
  }, [isPaused]);

  // Touch swipe support for mobile
  const minSwipeDistance = 45;
  const onTouchStart = (e) => {
    setTouchEnd(null);
    setTouchStart(e.targetTouches[0].clientX);
  };
  const onTouchMove = (e) => {
    setTouchEnd(e.targetTouches[0].clientX);
  };
  const onTouchEnd = () => {
    if (!touchStart || !touchEnd) return;
    const distance = touchStart - touchEnd;
    if (distance > minSwipeDistance) {
      nextSlide();
    } else if (distance < -minSwipeDistance) {
      prevSlide();
    }
  };

  return (
    <>
      <section className="luxury-hero-section">
        {/* Luxury Hero Banner Slider (Desktop & Mobile Responsive) */}
        <div 
          className="luxury-hero-slider-wrapper"
          onMouseEnter={() => setIsPaused(true)}
          onMouseLeave={() => setIsPaused(false)}
          onTouchStart={onTouchStart}
          onTouchMove={onTouchMove}
          onTouchEnd={onTouchEnd}
        >
          <div className="luxury-hero-slider">
            {HERO_SLIDES.map((slide, idx) => (
              <div
                key={slide.id}
                className={`hero-slide-item ${idx === activeSlide ? "active" : ""}`}
                aria-hidden={idx !== activeSlide}
              >
                <picture className="hero-slide-picture">
                  <source media="(max-width: 767.98px)" srcSet={slide.mobile} />
                  <img
                    src={slide.desktop}
                    alt={slide.alt}
                    className="hero-slide-img"
                    loading={idx === 0 ? "eager" : "lazy"}
                    fetchPriority={idx === 0 ? "high" : "auto"}
                  />
                </picture>
              </div>
            ))}

            {/* Previous Slide Button */}
            <button
              type="button"
              className="hero-slider-nav-btn hero-slider-prev"
              onClick={prevSlide}
              aria-label="Previous banner"
            >
              <FiChevronLeft />
            </button>

            {/* Next Slide Button */}
            <button
              type="button"
              className="hero-slider-nav-btn hero-slider-next"
              onClick={nextSlide}
              aria-label="Next banner"
            >
              <FiChevronRight />
            </button>
          </div>
        </div>

        {/* Floating Search Finder Card */}
        <div className="finder-floating-wrapper">
          <div className="container">
            <div className="luxury-finder-card">
              {/* Corner Gold Flourish */}
              <div className="finder-corner-ornament" />

              {/* Finder Header */}
              <div className="finder-card-header">
                <div className="finder-header-left">
                  <div className="finder-search-circle-icon">
                    <FiSearch />
                  </div>
                  <h3 className="finder-title">Find Your Perfect Match</h3>
                  <span className="finder-subtitle">Begin your journey to a beautiful relationship</span>
                </div>
              </div>

              {/* Finder Search Form */}
              <form onSubmit={handleSubmit} className="finder-form">
                <div className="finder-fields-grid">
                  {/* Field 1: I am looking for */}
                  <div className="finder-field-box">
                    <div className="field-icon-wrap">
                      <FiUser className="field-icon" />
                    </div>
                    <div className="field-body">
                      <label className="field-label">I am looking for</label>
                      <select
                        name="lookingFor"
                        value={formData.lookingFor}
                        onChange={handleChange}
                        className="finder-select"
                        aria-label="I am looking for"
                      >
                        <option value="female">Bride</option>
                        <option value="male">Groom</option>
                      </select>
                    </div>
                  </div>

                  {/* Field 2: Age */}
                  <div className="finder-field-box">
                    <div className="field-icon-wrap">
                      <FiCalendar className="field-icon" />
                    </div>
                    <div className="field-body">
                      <label className="field-label">Age</label>
                      <select
                        name="ageRange"
                        value={formData.ageRange}
                        onChange={handleChange}
                        className="finder-select"
                        aria-label="Age range"
                      >
                        <option value="18 - 25">18 - 25</option>
                        <option value="21 - 30">21 - 30</option>
                        <option value="18 - 35">18 - 35</option>
                        <option value="25 - 35">25 - 35</option>
                        <option value="28 - 40">28 - 40</option>
                        <option value="30 - 50">30 - 50</option>
                        <option value="21 - 60">21 - 60</option>
                      </select>
                    </div>
                  </div>

                  {/* Field 3: Religion / Community */}
                  <div className="finder-field-box">
                    <div className="field-icon-wrap">
                      <FiUsers className="field-icon" />
                    </div>
                    <div className="field-body">
                      <label className="field-label">Religion / Community</label>
                      <select
                        name="caste"
                        value={formData.caste}
                        onChange={handleChange}
                        className="finder-select"
                        aria-label="Religion or Community"
                      >
                        <option value="">Select</option>
                        <option value="All Hindu">All Hindu Communities</option>
                        {casteOptions.map((caste, idx) => (
                          <option key={idx} value={caste}>
                            {caste}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>

                  {/* Field 4: Mother Tongue */}
                  <div className="finder-field-box">
                    <div className="field-icon-wrap">
                      <FiMessageSquare className="field-icon" />
                    </div>
                    <div className="field-body">
                      <label className="field-label">Mother Tongue</label>
                      <select
                        name="motherTongue"
                        value={formData.motherTongue}
                        onChange={handleChange}
                        className="finder-select"
                        aria-label="Mother Tongue"
                      >
                        <option value="">Select</option>
                        {MOTHER_TONGUES.map((lang, idx) => (
                          <option key={idx} value={lang}>
                            {lang}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>

                  {/* Field 5: City */}
                  <div className="finder-field-box">
                    <div className="field-icon-wrap">
                      <FiMapPin className="field-icon" />
                    </div>
                    <div className="field-body">
                      <label className="field-label">City</label>
                      <select
                        name="city"
                        value={formData.city}
                        onChange={handleChange}
                        className="finder-select"
                        aria-label="City"
                      >
                        <option value="">Select City</option>
                        {POPULAR_CITIES.map((cityName, idx) => (
                          <option key={idx} value={cityName}>
                            {cityName}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>

                  {/* Search Button */}
                  <div className="finder-action-box">
                    <button
                      type="submit"
                      className="finder-submit-btn"
                      disabled={loading}
                    >
                      <FiSearch className="btn-search-icon" />
                      <span>{loading ? "Searching..." : "Search Now"}</span>
                    </button>
                  </div>
                </div>
              </form>
            </div>

            {/* Social Proof Bar */}
            <div className="hero-social-proof-bar">
              <div className="social-proof-content">
                <span className="proof-text-strong">Trusted by 12,00,000+ Families</span>
                <div className="proof-avatar-stack">
                  <img src={user1} alt="Member" className="avatar-img" />
                  <img src={user2} alt="Member" className="avatar-img" />
                  <img src={user3} alt="Member" className="avatar-img" />
                  <img src={user4} alt="Member" className="avatar-img" />
                  <img src={user5} alt="Member" className="avatar-img" />
                  <span className="avatar-count-badge">12L+</span>
                </div>
                <span className="proof-text-muted">and counting...</span>
              </div>
              <div className="proof-bottom-heart">
                <FaHeart className="small-heart-accent" />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Search Results Modal */}
      <Modal
        backdrop="static"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        keyboard={false}
        show={isOpenModal}
        size="xl"
        onHide={handleModal}
        className="luxury-results-modal"
      >
        <Modal.Header closeButton className="border-0 pb-0">
          <Modal.Title className="fw-bold text-dark fs-4">
            Matching Profiles for You
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="pt-2">
          <div className="row g-3">
            {!apiData?.users || apiData?.users?.length === 0 ? (
              <div
                className="position-relative nodataBox w-100 py-5 text-center"
                style={{
                  backgroundImage: `url(${NoDataImage})`,
                  backgroundSize: "cover",
                  borderRadius: "12px",
                }}
              >
                <div className="py-4">
                  <h3 className="text-white fw-bold mb-3">No Immediate Match Found</h3>
                  <p className="text-white-50 mb-4">Try broadening your search criteria or explore recently joined members.</p>
                  <div className="d-flex justify-content-center gap-3">
                    <Button onClick={handleModal} variant="light" className="px-4 fw-bold">
                      Modify Search
                    </Button>
                    <Link to="/recently-joined-matches/" className="btn btn-danger px-4 fw-bold">
                      View All Members
                    </Link>
                  </div>
                </div>
              </div>
            ) : (
              apiData.users.map((member) => (
                <Link
                  to="/login"
                  key={member.user_id}
                  className="col-12 col-sm-6 col-md-4 col-lg-3 text-decoration-none"
                >
                  <div className="card h-100 border-0 shadow-sm rounded-4 overflow-hidden member-result-card">
                    <div className="member-photo-wrapper position-relative" style={{ height: "240px" }}>
                      <MemberPhotoSlider
                        images={getUserImages(member)}
                        alt={member.name}
                        imageClassName="w-100 h-100 object-fit-cover"
                      />
                      <span className="badge bg-danger position-absolute top-0 end-0 m-2 rounded-pill">
                        HS{member.user_id}
                      </span>
                    </div>
                    <div className="card-body p-3">
                      <h5 className="card-title fw-bold text-dark text-truncate mb-1">
                        {member.name}
                      </h5>
                      <div className="text-muted small mb-2">
                        {calculateAge(member.dob)} Yrs • {formatHeight(member.height)} • {member.gender === "male" ? "Male" : "Female"}
                      </div>
                      <div className="d-flex flex-column gap-1 small text-secondary">
                        <div>
                          <strong>Caste:</strong> {member.caste || "Hindu"}
                        </div>
                        <div>
                          <strong>Location:</strong> {member.curr_location || member.city || member.country || "India"}
                        </div>
                      </div>
                      <div className="mt-3">
                        <button className="btn btn-outline-danger btn-sm w-100 rounded-pill fw-bold">
                          View Full Profile
                        </button>
                      </div>
                    </div>
                  </div>
                </Link>
              ))
            )}
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}

